export default {
  user_login: 'api/user/login',

  exercise_type_list: 'api/exercise/type/index',
  exercise_type_create: 'api/exercise/type/create',
  exercise_type_update: 'api/exercise/type/update',
  exercise_type_delete: 'api/exercise/type/delete',
  exercise_type_view: 'api/exercise/type/view',

  exercise_list: 'api/exercise/index',
  exercise_create: 'api/exercise/create',
  exercise_update: 'api/exercise/update',
  exercise_delete: 'api/exercise/delete',
  exercise_view: 'api/exercise/view',

  exercise_check: 'api/exercise/check/index',
  exercise_check_update: 'api/exercise/check/update',
  exercise_check_delete: 'api/exercise/check/delete',
  exercise_check_types: 'api/exercise/check/types',

  exercise_word: 'api/exercise/word/index',
  exercise_word_create: 'api/exercise/word/create',
  exercise_word_update: 'api/exercise/word/update',
  exercise_word_delete: 'api/exercise/word/delete',
  exercise_word_reset: 'api/exercise/word/update-exercise',

  exercise_qa: 'api/exercise/qa/index',
  exercise_qa_create: 'api/exercise/qa/create',
  exercise_qa_update: 'api/exercise/qa/update',
  exercise_qa_delete: 'api/exercise/qa/delete',
  exercise_qa_build: 'api/exercise/qa/build',
  exercise_qa_rebuild: 'api/exercise/qa/rebuild',
  exercise_qa_history: 'api/exercise/qa/history',
  exercise_qa_question: 'api/exercise/qa/question',

  exercise_files: 'api/exercise/file-desc/index',
  exercise_files_view: 'api/exercise/file-desc/view',
  exercise_files_update: 'api/exercise/file-desc/update',

  kewen_list: 'api/kewen/index',
  kewen_create: 'api/kewen/create',
  kewen_update: 'api/kewen/update',
  kewen_delete: 'api/kewen/delete',
  kewen_view: 'api/kewen/view',
  kewen_paragraphs: 'api/kewen/paragraphs',
  kewen_generate_exercise: 'api/kewen/generate-exercise',

  kewen_role_list: 'api/kewen/role/index',
  kewen_role_create: 'api/kewen/role/create',
  kewen_role_update: 'api/kewen/role/update',
  kewen_role_delete: 'api/kewen/role/delete',
  kewen_role_view: 'api/kewen/role/view',

  word_list: 'api/word/index',
  word_view: 'api/word/view',
  word_create: 'api/word/create',
  word_update: 'api/word/update',
  word_delete: 'api/word/delete',

  word_check: 'api/word/check/index',
  word_check_update: 'api/word/check/update-word',
  word_check_delete: 'api/word/check/delete',

  grammar_list: 'api/grammar/index',
  grammar_view: 'api/grammar/view',
  grammar_create: 'api/grammar/create',
  grammar_update: 'api/grammar/update',
  grammar_delete: 'api/grammar/delete',

  grammar_graphic_list: 'api/grammar/graphic/index',

  grammar_type_list: 'api/grammar/type/index',
  grammar_type_treelist: 'api/grammar/type/list',
  grammar_type_create: 'api/grammar/type/create',
  grammar_type_update: 'api/grammar/type/update',
  grammar_type_delete: 'api/grammar/type/delete',

  lesson_list: 'api/lesson/index',
  lesson_create: 'api/lesson/create',
  lesson_update: 'api/lesson/update',
  lesson_delete: 'api/lesson/delete',
  lesson_view: 'api/lesson/view',
  lesson_items: 'api/lesson/items',

  lesson_unit_list: 'api/lesson/unit/index',
  lesson_unit_create: 'api/lesson/unit/create',
  lesson_unit_update: 'api/lesson/unit/update',
  lesson_unit_delete: 'api/lesson/unit/delete',
  lesson_unit_view: 'api/lesson/unit/view',

  lesson_coll_list: 'api/lesson/collection/index',
  lesson_coll_create: 'api/lesson/collection/create',
  lesson_coll_update: 'api/lesson/collection/update',
  lesson_coll_delete: 'api/lesson/collection/delete',
  lesson_coll_view: 'api/lesson/collection/view',
  lesson_coll_refresh: 'api/lesson/collection/refresh',

  lesson_entity_list: 'api/lesson/entity/index',
  lesson_entity_create: 'api/lesson/entity/create',
  lesson_entity_update: 'api/lesson/entity/update',
  lesson_entity_delete: 'api/lesson/entity/delete',
  lesson_entity_batchupdate: 'api/lesson/entity/batch-update',
  lesson_entity_batchdelete: 'api/lesson/entity/batch-delete',
  lesson_entity_sort: 'api/lesson/entity/sort',

  locale_search: 'api/locale/search',
  locale_update: 'api/locale/update',

  pinyin_list: 'api/pinyin/index',
  pinyin_create: 'api/pinyin/create',
  pinyin_update: 'api/pinyin/update',
  pinyin_delete: 'api/pinyin/delete',
  pinyin_items: 'api/pinyin/items',

  pinyin_intro_list: 'api/pinyin/intro/index',
  pinyin_intro_create: 'api/pinyin/intro/create',
  pinyin_intro_update: 'api/pinyin/intro/update',
  pinyin_intro_delete: 'api/pinyin/intro/delete',

  pinyin_lesson_list: 'api/pinyin/lesson/index',
  pinyin_lesson_create: 'api/pinyin/lesson/create',
  pinyin_lesson_update: 'api/pinyin/lesson/update',
  pinyin_lesson_delete: 'api/pinyin/lesson/delete',
  pinyin_lesson_group: 'api/pinyin/lesson/group',
  pinyin_lesson_view: 'api/pinyin/lesson/view',
  pinyin_lesson_item: 'api/pinyin/lesson/item',
  pinyin_lesson_itemupdate: 'api/pinyin/lesson/item-update',
  pinyin_lesson_itemdelete: 'api/pinyin/lesson/item-delete',
  pinyin_lesson_itemsort: 'api/pinyin/lesson/item-sort',

  pinyin_exercise_list: 'api/pinyin/exercise/index',
  pinyin_exercise_create: 'api/pinyin/exercise/create',
  pinyin_exercise_update: 'api/pinyin/exercise/update',
  pinyin_exercise_delete: 'api/pinyin/exercise/delete',

  pinyin_comb_list: 'api/pinyin/comb/index',
  pinyin_comb_create: 'api/pinyin/comb/create',
  pinyin_comb_update: 'api/pinyin/comb/update',
  pinyin_comb_delete: 'api/pinyin/comb/delete',
  pinyin_comb_items: 'api/pinyin/comb/items',

  test_exercise_list: 'api/test/exercise/index',
  test_exercise_update: 'api/test/exercise/update',
  test_exercise_create: 'api/test/exercise/create',
  test_exercise_points: 'api/test/exercise/points',

  tag_list: 'api/tag/index',
  tag_treelist: 'api/tag/list',
  tag_create: 'api/tag/create',
  tag_update: 'api/tag/update',
  tag_delete: 'api/tag/delete',

  dict_list: 'api/dict/index',
  dict_create: 'api/dict/create',
  dict_update: 'api/dict/update',
  dict_delete: 'api/dict/delete',

  dict_missing_list: 'api/dict/missing/index',
  dict_missing_create: 'api/dict/missing/create',
  dict_missing_update: 'api/dict/missing/update',
  dict_missing_delete: 'api/dict/missing/delete',

  sentence_list: 'api/sentence/index',
  sentence_view: 'api/sentence/view',
  sentence_create: 'api/sentence/create',
  sentence_update: 'api/sentence/update',
  sentence_delete: 'api/sentence/delete',

  sentence_check: 'api/sentence/check/index',
  sentence_check_update: 'api/sentence/check/update',
  sentence_check_delete: 'api/sentence/check/delete',

  sentence_word: 'api/sentence/word/index',
  sentence_word_create: 'api/sentence/word/create',
  sentence_word_update: 'api/sentence/word/update',
  sentence_word_delete: 'api/sentence/word/delete',
  sentence_word_reset: 'api/sentence/word/reset',

  filemanager_images: 'api/file-manager/image',
  filemanager_audios: 'api/file-manager/audio',

  // graphic
  graphic_list: 'api/graphic/graphic/index',
  graphic_create: 'api/graphic/graphic/create',
  graphic_update: 'api/graphic/graphic/update',
  graphic_archive_list: 'api/graphic/archive/index',
  graphic_archive_data: 'api/graphic/archive/data',
  graphic_archive_create: 'api/graphic/archive/create',
  graphic_archive_update: 'api/graphic/archive/update',
  graphic_archive_save: 'api/graphic/archive/save',
  graphic_archive_publish: 'api/graphic/archive/publish',
  graphic_archive_move: 'api/graphic/archive/move',
  graphic_archive_delete: 'api/graphic/archive/del',
  graphic_detail_data: 'api/graphic/detail/data',
  graphic_text_list: 'api/graphic/text/index',
  graphic_text_create: 'api/graphic/text/create',
  graphic_text_update: 'api/graphic/text/update',
  graphic_text_delete: 'api/graphic/text/delete',

  talk_item_list: 'api/talk/item/index',
  talk_item_view: 'api/talk/item/view',
  talk_item_create: 'api/talk/item/create',
  talk_item_update: 'api/talk/item/update',
  talk_item_delete: 'api/talk/item/delete',
  talk_item_hints_list: 'api/talk/hints/index',
  talk_item_hints_view: 'api/talk/hints/view',
  talk_item_hints_create: 'api/talk/hints/create',
  talk_item_hints_update: 'api/talk/hints/update',
  talk_item_hints_delete: 'api/talk/hints/delete',

  review_knowl_sentence_list: 'api/review/sentence/index',
  review_knowl_sentence_create: 'api/review/sentence/create',
  review_knowl_sentence_update: 'api/review/sentence/update',
  review_knowl_sentence_delete: 'api/review/sentence/delete',
}
